import { useEffect } from "react";

const SITE_URL = "https://rae-enterprise.com";
const DEFAULT_OG = `${SITE_URL}/og-image.png`;

function upsertMeta(kind, key, value) {
  const selector = `meta[${kind}="${key}"]`;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(kind, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Per-page SEO. Updates title, description, OG, Twitter, canonical.
 */
export default function useSEO({ title, description, path = "/", image = DEFAULT_OG, type = "website" }) {
  useEffect(() => {
    const fullTitle = title.includes("Rae Enterprise") ? title : `${title} | Rae Enterprise LLC`;
    const fullUrl = `${SITE_URL}${path}`;

    document.title = fullTitle;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", fullUrl);
    upsertMeta("property", "og:image", image);
    upsertMeta("property", "og:type", type);
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image);
    setCanonical(fullUrl);
  }, [title, description, path, image, type]);
}
